export default {
    defaults: {
        avatar:         'https://firebasestorage.googleapis.com/v0/b/theuniverse-f5c32.appspot.com/o/app%2Fprofile%2FdefaultAvatar.jpg?alt=media&token=c96bc1ae-90a0-4b27-b654-d0e34a083749',
        cover:          'https://firebasestorage.googleapis.com/v0/b/theuniverse-f5c32.appspot.com/o/app%2Fprofile%2FdefaultCover.jpg?alt=media&token=cf25bcf8-b2e2-445f-906a-e622b6e18350',
    },
    backgrounds: {
        aboutTheAuthor: 'https://firebasestorage.googleapis.com/v0/b/theuniverse-f5c32.appspot.com/o/app%2Fcovers%2Fcover-texture.jpg?alt=media&token=9a378e22-3f17-4bf3-ba88-d7e2dc5f579d',
        donate:         'https://firebasestorage.googleapis.com/v0/b/theuniverse-f5c32.appspot.com/o/app%2Fcovers%2Fcover-texture.jpg?alt=media&token=9a378e22-3f17-4bf3-ba88-d7e2dc5f579d',
    },
    adEngine: {
        register:       'https://firebasestorage.googleapis.com/v0/b/theuniverse-f5c32.appspot.com/o/app%2FadEngine%2Funiverse-ad-register.jpg?alt=media&token=190e636a-a453-404e-96cb-c83a1f7a873f'
    },
    covers: {
        recrop:         'https://firebasestorage.googleapis.com/v0/b/theuniverse-f5c32.appspot.com/o/app%2Fcovers%2Fcover-recrop.jpg?alt=media&token=2db834e5-f222-4858-bffa-17d6393649cb',
        login:          'https://firebasestorage.googleapis.com/v0/b/theuniverse-f5c32.appspot.com/o/app%2Fcovers%2Fcover-login.jpg?alt=media&token=c87319b6-da41-4802-bc1e-583f20a1735d',
        contact:        'https://firebasestorage.googleapis.com/v0/b/theuniverse-f5c32.appspot.com/o/app%2Fcovers%2Fcover-contact.jpg?alt=media&token=52c650d2-b5b9-4616-9089-39c2783a24cb'
    },
    limits: {
        username: {
            min: 3,
            max: 25
        },
        entry: {
            carousel: {
                max: 8,
            },
            url: {
                min: 5,
                max: 80,
            },
            title: 40,
            subtitle: 60,
            intro: 400,
            story: 8000,
        }
    }
}